import cx from 'classnames';
import styles from './CSVRow.module.scss';
import { CSVRowCombinedProps } from './types';
import getProps from './CSVRow.props';

const usePresenter = (props: CSVRowCombinedProps): CSVRowCombinedProps => {
  const {
    styleType,
    htmlTag,
    classes,
    checkbox,
    name,
    email,
    role,
  } = props;

  const variantName = `${htmlTag || ''}${styleType}`;
  const internalProps = getProps(variantName);

  return {
    ...props,
    checkbox: {
      targetProps: {
        className: cx(styles.checkbox, classes?.checkbox),
        ...internalProps.checkbox,
        ...checkbox?.targetProps,
      },
    },
    name: {
      targetProps: {
        className: cx(styles.name, props.classes?.name),
        ...internalProps.name,
        ...name?.targetProps,
      },
    },
    email: {
      targetProps: {
        className: cx(styles.email, props.classes?.email),
        ...internalProps.email,
        ...email?.targetProps,
      },
    },
    role: {
      targetProps: {
        className: cx(styles.role, props.classes?.role),
        ...internalProps.role,
        ...role?.targetProps,
      },
    },
  };
};

export default usePresenter;
